// src/components/home/TodayPick.tsx
import React, { useEffect, useState } from "react";
import styles from "./TodayPick.module.css";

type Props = {
  /** LP版（軽量表示）にしたい場合は "lp" を渡す。既定は "home" */
  variant?: "home" | "lp";
};

type RecPlan = {
  id: number;
  name: string;
  imageUrl?: string;
};

const API_PUBLIC = "/api/public";

function toAbsImage(url?: string): string {
  if (!url || !url.trim()) return "/assets/member/noimage.webp";
  return url;
}

export default function TodayPick({ variant = "home" }: Props) {
  const isLP = variant === "lp";
  const [items, setItems] = useState<RecPlan[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const res = await fetch(`${API_PUBLIC}/recommended?t=${Date.now()}`, {
          credentials: "include",
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        const json = await res.json();
        if (!cancelled && Array.isArray(json)) setItems(json);
      } catch (e) {
        console.error("[TodayPick] fetch failed:", e);
        if (!cancelled) setItems([]);
      } finally {
        if (!cancelled) setLoaded(true);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className={`${styles.todayPick} ${isLP ? styles.lp : styles.home}`}>
      {/* === バナー === */}
      <div className={styles.banner}>
        <img src="/assets/member/banner1.webp" alt="本日の一押し!!" />
      </div>

      {/* === API連動プラン === */}
      <div className={styles.content}>
        {!loaded ? (
          <p style={{ color: "#fff", opacity: 0.8 }}>読み込み中…</p>
        ) : items.length === 0 ? (
          <p style={{ color: "#fff", opacity: 0.8 }}>現在おすすめはありません。</p>
        ) : (
          items.map((p) => {
            const img = toAbsImage(p.imageUrl);

            return (
              <React.Fragment key={p.id}>
                {/* 画像 */}
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                  }}
                >
                  <img
                    src={img}
                    alt={p.name}
                    className={styles.planImg}
                    loading="lazy"
                  />
                </div>

                {/* 購入ボタン + キャラ */}
                <div className={styles.desc}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 14,
                      marginTop: 14,
                    }}
                  >
                    <a
                      href={`/plans/${p.id}`}
                      aria-label="購入画面へ"
                      style={{ display: "inline-block", textAlign: "center" }}
                    >
                      <img
                        src="/assets/member/red_button_buy_small.webp"
                        alt="購入画面へ"
                        style={{ width: 220, height: "auto" }}
                        loading="lazy"
                      />
                    </a>

                    {/* キャラクター */}
                    <img
                      src="/assets/member/character.webp"
                      alt="案内キャラクター"
                      loading="lazy"
                      style={{
                        display: "block",
                        width: 220,
                        height: "auto",
                        marginTop: 12,
                        filter: "drop-shadow(0 4px 10px rgba(0,0,0,.25))",
                      }}
                    />
                  </div>
                </div>
              </React.Fragment>
            );
          })
        )}
      </div>
    </section>
  );
}
